
import React, { Fragment } from 'react'

export const AppActionDemo = () =>{
    return (<div className='app-demo-content'>
            <h1>合适使用</h1>    
            <div>
                操作按钮，需要用户界面交互时使用。每个类型的按钮都建议设置actionCode，用于权限体系过滤。
            </div>
    </div>)
}


// WEBPACK FOOTER //
// ./src/modules/Demo/components/platform/AppActionDemo.tsx